export default "__VITE_ASSET__BXGlNrzL__"